import * as React from 'react';
import { SVGProps } from 'react';

const SvgFeedback = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 15.598C4 9.193 9.193 4 15.598 4c6.349 0 11.507 5.103 11.597 11.43l2.415 6.69c.28.762-.301 1.523-1.068 1.523h-1.727v1.09c0 2.51-1.91 4.568-4.356 4.81v2.634h-1.883v-4.495h1.4a2.95 2.95 0 0 0 2.955-2.95V21.76h2.546l-2.165-5.996v-.165c0-5.364-4.35-9.714-9.714-9.714-5.364 0-9.714 4.35-9.714 9.714 0 4.622 3.228 8.49 7.553 9.473l.733.166v6.94h-1.884v-5.461C7.495 25.29 4 20.854 4 15.598Z"
      clipRule="evenodd"
    />
    <path fill={props.fill} d="M26.343 35.019H12.26v-3.892h10.185l3.9 3.892Z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m35.367 24.448-2.918-.004.002-1.884 2.919.004-.003 1.884Zm-.891-5.48-2.53 1.455-.939-1.633 2.53-1.455.94 1.633Zm-.939 10.698-2.53-1.455.94-1.633 2.53 1.455-.94 1.633Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgFeedback;
